import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { IonIcon } from '@ionic/angular/standalone';

import { addIcons } from 'ionicons';

import { MAIN_NAV_ICONS } from '@core/constants/nav-items.constant';
import { NavItem } from '@core/interfaces';

@Component({
  selector: 'x-bottom-nav',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, RouterLinkActive, IonIcon],
  templateUrl: './x-bottom-nav.component.html',
  styleUrl: './x-bottom-nav.component.scss',
})
export class XBottomNavComponent {
  readonly items = input.required<readonly NavItem[]>();

  constructor() {
    addIcons(MAIN_NAV_ICONS);
  }
}
